import { render, staticRenderFns } from "./CatalogCreate.vue?vue&type=template&id=5e98eae0&scoped=true"
import script from "./CatalogCreate.vue?vue&type=script&lang=js"
export * from "./CatalogCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e98eae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e98eae0')) {
      api.createRecord('5e98eae0', component.options)
    } else {
      api.reload('5e98eae0', component.options)
    }
    module.hot.accept("./CatalogCreate.vue?vue&type=template&id=5e98eae0&scoped=true", function () {
      api.rerender('5e98eae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/CatalogCreate.vue"
export default component.exports